export const NAVBAR_DRAWER_WIDTH = '3.5rem';
export const HEADER_HEIGHT = '55px';
